import { useFormContext } from 'react-hook-form'
import { getBusinessEventLabel, IntegrationServiceId } from '../../../../../../../common/integrations'
import { IntegrationSettings } from '../../../schema'
import React, { useCallback } from 'react'
import Row from 'react-bootstrap/esm/Row'
import { Accordion, Col, Form } from 'react-bootstrap'
import { MappingType } from '../../../../../../../models/Account'
import { BusinessEventType } from '../../../../../../../models/BusinessEvent'
import { BusinessEventsBody } from './BusinessEventsBody'

import './BusinessEventsRow.scss'

interface BusinessEventsRowProps {
  serviceId: IntegrationServiceId
  businessEventType: BusinessEventType
}

export const BusinessEventsRow: React.FC<BusinessEventsRowProps> = ({ serviceId, businessEventType }) => {
  const { watch, setValue } = useFormContext<IntegrationSettings>()
  const mappingPath = `mappings.businessEvents.${businessEventType}` as const
  const currentBusinessEventMapping = watch(mappingPath)
  const currentMappingType = watch(`${mappingPath}.mappingType` as const)
  const objectName = watch(`${mappingPath}.objectName` as const)
  const fields = watch(`${mappingPath}.fields` as const)
  const fieldCount = Object.keys(fields ?? {}).length

  const isCustom = currentMappingType === MappingType.CUSTOM

  const enabledBusinessEventTypes = (watch('enabledBusinessEventTypes') ?? []) as BusinessEventType[]
  const isEnabled = enabledBusinessEventTypes.includes(businessEventType)

  const handleToggleEnabled = useCallback(() => {
    const current = (watch('enabledBusinessEventTypes') ?? []) as BusinessEventType[]
    if (current.includes(businessEventType)) {
      setValue(
        'enabledBusinessEventTypes',
        current.filter((t) => t !== businessEventType),
        { shouldDirty: true, shouldValidate: true },
      )
    } else {
      setValue('enabledBusinessEventTypes', [...current, businessEventType], { shouldDirty: true, shouldValidate: true })
    }
  }, [businessEventType, watch, setValue])

  return (
    <Row>
      <Col className='p-0'>
        <Accordion className='no-arrow'>
          <Accordion.Item eventKey={String(businessEventType)}>
            <Accordion.Header>
              <div className='business-event-row-content'>
                <div className='d-flex align-items-center gap-2'>
                  <div className='d-flex align-items-start gap-2' onClick={(e) => e.stopPropagation()}>
                    <Form.Check className='d-flex align-items-center' type='checkbox' checked={isEnabled} onChange={handleToggleEnabled} />
                  </div>
                  <div className='d-flex align-items-center justify-content-center h6'>{getBusinessEventLabel(businessEventType)}</div>
                </div>

                {currentBusinessEventMapping && isCustom ? (
                  <div className='configured-text'>
                    {objectName} - {fieldCount} field{fieldCount > 0 ? 's' : ''}
                  </div>
                ) : (
                  <div className='not-configured-text'>Not configured </div>
                )}
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <BusinessEventsBody serviceId={serviceId} businessEventType={businessEventType} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Col>
    </Row>
  )
}
